import { render, staticRenderFns } from "./ShorexSummary.vue?vue&type=template&id=5c19109b&scoped=true"
import script from "./ShorexSummary.vue?vue&type=script&lang=js"
export * from "./ShorexSummary.vue?vue&type=script&lang=js"
import style0 from "./ShorexSummary.vue?vue&type=style&index=0&id=5c19109b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19109b",
  null
  
)

export default component.exports